import { en } from './en'
import { zhHant } from './zh-Hant'

export enum Languages {
  traditionalChinese = 'zh-Hant',
  english = 'en',
}

export const languagePack = {
  [Languages.traditionalChinese]: zhHant,
  [Languages.english]: en,
} as const
